export default __webpack_public_path__ + "static/media/sbct-back.cf5b1b75.jpg";